<app-block-wrapper [_editable]="_editable" [style]="style">
  <div
    class="storyblok-content-block force-primary-links size-{{ textSize }} color-override-{{ colorOverride }} {{
      alignment || 'center'
    }} a-m-{{ mobileAlignment }} a-t-{{ tabletAlignment }} a-d-{{ desktopAlignment }}"
    [innerHTML]="content | storyblokRichText | replaceText : replacer"
    appRouteDirective
  ></div>
  <div class="empty" *ngIf="content && !content.content[0]?.text && !content.content[0].content">EMPTY CONTENT</div>
</app-block-wrapper>
